import { createEffect, untrack } from "solid-js"
import { Group, Mesh, type Object3D } from "three"
import type { Engine } from "../../core/engine/Engine.type"
import type { EntityGraphNode } from "../../core/engine/EntityGraphNode/EntityGraphNode.type"
import applyEntityRotationToNextObject3DFrame from "../../core/entity/EntityHeading/applyEntityRotationToNextObject3DFrame"
import applyEntityWalkPathToNextObject3DFrame from "../../core/entity/EntityHeading/applyEntityWalkPathToNextObject3DFrame"
import type { MediumCopterEntity } from "../../core/entity/EntityType/MediumCopter"
import shouldEntityShowFadedFrames from "../../core/entity/shouldEntityShowFadedFrames"
import tmpRng from "../../core/rng/tmpRng"
import { sin } from "../../core/util/math/Math"
import { mountOnFrameUpdateToObject3D } from "../../event/GameObject3D/GameObject3DFrameUpdate/GameObject3DFrameUpdate"
import assertClassInDev from "../../ldsh/assertClassInDev"
import { AH64Apache1_AH64Apache1_GLTF_Model } from "../gltf_models.generated"
import { appGltfLoader } from "./appGltfLoader"
import applyPlayerColors from "./applyPlayerColors"
import runWithObject3DOwner from "./runWithObject3DOwner"

export default function makeMediumCopterScene(
  engine: Engine,
  ent: EntityGraphNode<MediumCopterEntity>,
  callback: (newGroup: Object3D) => void
): void {
  return appGltfLoader.load(AH64Apache1_AH64Apache1_GLTF_Model, function (ModelObj) {
    tmpRng.seed = ent.id
    const { scene } = ModelObj
    // console.log('MediumCopter', scene)

    // scene.scale.multiplyScalar(10)

    // scene.position.y -= 4

    const frontRotorGroup = scene.getObjectByName('Rotor1') as Group
    assertClassInDev(frontRotorGroup, Group)
    // console.log('frontRotorGroup', frontRotorGroup)

    const rearRotorMesh = scene.getObjectByName('Rotor2') as Mesh
    assertClassInDev(rearRotorMesh, Mesh)
    // console.log('rearRotorMesh', rearRotorMesh)

    applyPlayerColors(engine, scene, ent)

    // group.position.y += 3

    // set base render height
    scene.userData.y = scene.position.y

    let entValue = untrack(ent.raw)
    runWithObject3DOwner(scene, () => {
      createEffect(() => {
        entValue = ent.raw()
      })
    })

    mountOnFrameUpdateToObject3D(engine, scene, (elapsedMs: number, frameAt: number): void => {
      // const mod = frameAt % totalLoopMs
      if (shouldEntityShowFadedFrames(entValue)) {
        scene.position.y = scene.userData.y
      } else if (entValue.player_id) {
        scene.position.y = scene.userData.y + ((sin(frameAt / 1000)) + 4)
        frontRotorGroup.rotation.y = (frameAt / 120)
        rearRotorMesh.rotation.x = (-frameAt / 80)
      }
      applyEntityRotationToNextObject3DFrame(scene, elapsedMs)
      applyEntityWalkPathToNextObject3DFrame(scene, elapsedMs)
    })

    callback(scene)
  })
}

